import { Document } from './../index';

export class DeviceDocument {
    public DeviceId: number;
    public DocuemtnId: number;
    public DownloadDate: Date;

    public Document: Document = new Document()
}
